<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Desembolso - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         

                <b-col sm="12" md="9">
          
                </b-col>

                
                <b-col sm="6" md="3">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListDisbursement"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <!-- <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('DisbursementAdd')" class="btn form-control btn-primary"  :to="{ path: '/desembolso/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col> -->
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="7%" class="text-center">Fecha</th>
                    <th width="35%" class="text-center">Cliente</th>
                    <th width="15%" class="text-center">M. Pago</th>
                    <th width="10%" class="text-center">Nro Referencia</th>
                    <th width="9%" class="text-center">Monto</th>
                    <th width="10%" class="text-center">Usuario</th>
                    <th width="6%" class="text-center">Estado</th>
                    <th width="5%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.date  }}</td>
                    <td class="text-left"> {{ item.name + " - " + item.document_number  }}</td>
                    <td class="text-left"> {{ NameMethodPayment(item.payment_method)  }}</td>
                    <td class="text-left"> {{ item.code  }}</td>
                    <td class="text-right"> {{ item.amount  }}</td>
                    <td class="text-right"> {{ item.user  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 2" variant="success">Finalizado</b-badge>
                        <b-badge v-if="item.state == 1" variant="warning">Pendiente</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Rechazado</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <!-- <b-dropdown-item v-if="Permission('DisbursementEdit')" @click="EditDisbursement(item.id_disbursement)" >Editar</b-dropdown-item> -->
                        <b-dropdown-item v-if="Permission('DisbursementView')" @click="ViewDisbursement(item.id_disbursement)" >Ver</b-dropdown-item>
                        <!-- <b-dropdown-item  v-if="Permission('DisbursementDelete')" @click="ConfirmDeleteDisbursement(item.id_disbursement)" >Eliminar</b-dropdown-item> -->
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListDisbursement" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "BranchOfficeList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'Disbursement',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      search: "",
    };
  },
  mounted() {
    this.ListDisbursement();
  },
  methods: {
    ListDisbursement,
    EditDisbursement,
    ViewDisbursement,
    ConfirmDeleteDisbursement,
    DeleteDisbursement,
    Permission,
    NameMethodPayment,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
  },
};

function NameMethodPayment(code) {
  return CodeToName.NameMethodPayment(code);
}

function ListDisbursement() {

  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url = this.url_base + "disbursement/list/"+ this.user.id_branch_office +"/"+ search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditDisbursement(id_disbursement) {
  this.$router.push({
    name: "DisbursementEdit",
    params: { id_disbursement: je.encrypt(id_disbursement) },
  });
}

// Ver Usuario
function ViewDisbursement(id_disbursement) {
  this.$router.push({
    name: "DisbursementView",
    params: { id_disbursement: je.encrypt(id_disbursement) },
  });
}

// Confirmar eliminar
function ConfirmDeleteDisbursement(id_disbursement) {
  Swal.fire({
    title: "Esta seguro de eliminar el desembolso?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteDisbursement(id_disbursement);
    }
  });
}

// eliminar usuario
function DeleteDisbursement(id_disbursement) {
  let me = this;
  let url = this.url_base + "disbursement/delete/" + id_disbursement;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_disbursement).indexOf(response.data.result.id_disbursement);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>